export default {
  'h-screen': '100vh',
  'w-screen': '100vw',
  '18': '4.5rem',
  '88': '22rem',
} as const
